import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './TermsAndConditions.css';

const AGB = () => {
  const isDe = useLocation().pathname.startsWith('/de');
  const homePath = isDe ? '/de' : '/';

  return (
    <div className="terms-of-use">
      <Link to={homePath}>
        <img style={{ filter: 'invert(1)' }} src="./img/bonusclub_logo.webp" alt="BonusClub" />
      </Link>

      <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
      <p>
        <strong>Stand: Mai 2026</strong>
      </p>

      <h2>1. Geltungsbereich, Vertragspartner, ausschließliche B2B-Nutzung</h2>
      <p>
        1.1 Diese Allgemeinen Geschäftsbedingungen („AGB“) gelten für sämtliche Verträge zwischen
        BonusClub LLC, eingetragene Anschrift: 7901 4TH ST N STE 300, St. Petersburg, FL 33702,
        USA („BonusClub“, „wir“, „uns“) und dem Kunden („Kunde“, „Sie“) über die Nutzung der
        unter <a href="https://www.bonusclub.io" target="_blank" rel="noopener noreferrer">www.bonusclub.io</a>,{' '}
        <a href="https://bonusclub.link" target="_blank" rel="noopener noreferrer">bonusclub.link</a>{' '}
        sowie zugehöriger Domains, Subdomains, Apps und Plattformen bereitgestellten
        Software-as-a-Service-Lösung („Dienst“ oder „Plattform“).
      </p>
      <p>
        1.2 Der Dienst richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB,
        juristische Personen des öffentlichen Rechts und öffentlich-rechtliche Sondervermögen.
        Der Kunde versichert mit Vertragsschluss, dass er den Vertrag in Ausübung seiner
        gewerblichen oder selbständigen beruflichen Tätigkeit abschließt. Eine Nutzung als
        Verbraucher im Sinne des § 13 BGB ist ausgeschlossen. Verbraucherschutzvorschriften,
        insbesondere das Widerrufsrecht nach § 312g BGB, finden keine Anwendung.
      </p>
      <p>
        1.3 Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des
        Kunden werden nicht Vertragsbestandteil, es sei denn, BonusClub stimmt ihrer Geltung
        ausdrücklich schriftlich zu. Diese AGB gelten auch dann ausschließlich, wenn BonusClub
        in Kenntnis entgegenstehender Bedingungen des Kunden Leistungen vorbehaltlos erbringt.
      </p>

      <h2>2. Vertragsgegenstand und Leistungsumfang</h2>
      <p>
        2.1 BonusClub stellt dem Kunden eine cloudbasierte Software zur Verfügung, mit deren
        Hilfe der Kunde eigene B2B-Kommunikations- und Outreach-Workflows organisieren,
        steuern, verwalten und ausführen kann (insbesondere E-Mail-Outreach, Multi-Channel-
        Sequenzen, Kontaktverwaltung, Pipeline- und Reporting-Funktionen).
      </p>
      <p>
        2.2 BonusClub stellt ausschließlich technische Infrastruktur bereit. BonusClub trifft
        keine Auswahl der Empfänger, Inhalte, Versandzeitpunkte, Frequenzen oder
        Kommunikationskanäle und bewertet diese auch nicht inhaltlich oder rechtlich. Sämtliche
        diesbezüglichen Entscheidungen trifft ausschließlich der Kunde.
      </p>
      <p>
        2.3 BonusClub ist weder Datenhändler, Lead-Verkäufer, Werbeagentur noch
        Kommunikationsdienstleister im Sinne des TKG/TDDDG. BonusClub stellt insbesondere
        keine Empfängerlisten, keine personenbezogenen Daten Dritter und keine vorgefertigten
        Versandinhalte bereit. Soweit über die Plattform Datenanreicherungen oder
        Drittintegrationen (z. B. E-Mail-Provider, CRM, Sending-Domains) angeboten oder
        zugänglich gemacht werden, erfolgt dies ausschließlich auf Veranlassung und unter
        Verantwortung des Kunden.
      </p>
      <p>
        2.4 Der Funktionsumfang ergibt sich aus der jeweils zum Zeitpunkt des Vertragsschlusses
        gültigen Leistungsbeschreibung sowie dem gewählten Tarif. BonusClub ist berechtigt, den
        Dienst weiterzuentwickeln, einzelne Funktionen zu ändern, zu erweitern oder durch
        gleichwertige Funktionen zu ersetzen, sofern dies dem Kunden zumutbar ist und der
        Kernumfang der vertraglichen Leistung nicht eingeschränkt wird.
      </p>
      <p>
        2.5 Eine bestimmte Zustellquote, Inbox-Platzierung, Antwortrate, Anzahl an Terminen,
        Conversions oder ein bestimmter wirtschaftlicher Erfolg werden nicht geschuldet.
        Aussagen in Marketingmaterialien, Demos oder Erfahrungsberichten Dritter stellen keine
        Beschaffenheits- oder Erfolgsgarantie im Sinne der §§ 443, 444 BGB dar.
      </p>

      <h2>3. Vertragsschluss und Registrierung</h2>
      <p>
        3.1 Der Vertrag kommt durch Registrierung des Kunden, Buchung eines Tarifs oder durch
        Abschluss eines individuellen Angebots zustande. Mit Bestätigung der AGB sowie der
        Auftragsverarbeitungsvereinbarung (AVV) wird der Vertrag rechtsverbindlich.
      </p>
      <p>
        3.2 Der Kunde ist verpflichtet, bei der Registrierung wahrheitsgemäße, vollständige
        und aktuelle Angaben zu machen und diese während der Vertragslaufzeit aktuell zu
        halten. Bei juristischen Personen ist die handelnde Person verpflichtet, ihre
        Vertretungsberechtigung sicherzustellen.
      </p>
      <p>
        3.3 Der Kunde ist für die Vertraulichkeit seiner Zugangsdaten verantwortlich. Der
        Kunde haftet für sämtliche Aktivitäten unter seinem Account, sofern ihn nicht
        ausnahmsweise kein Verschulden trifft. BonusClub ist im Verdachtsfall berechtigt,
        Accounts vorübergehend zu sperren.
      </p>

      <h2>4. Pflichten des Kunden, alleinige Verantwortung für Outreach</h2>
      <p>
        4.1 Der Kunde nutzt die Plattform eigenverantwortlich. Der Kunde ist alleiniger
        Verantwortlicher (Controller) im Sinne des Art. 4 Nr. 7 DSGVO für sämtliche über die
        Plattform durchgeführten Kommunikations- und Verarbeitungsvorgänge, insbesondere für
        die Auswahl der Empfänger, Inhalte, Frequenz, Versandzeitpunkte, Sender-Domains,
        Mailaccounts, Tracking-Mechanismen und Auswertungslogiken.
      </p>
      <p>
        4.2 Der Kunde stellt sicher, dass jeder mittels der Plattform durchgeführte Outreach
        sämtlichen anwendbaren Rechtsvorschriften entspricht, insbesondere - aber nicht
        beschränkt auf:
      </p>
      <ul>
        <li>(a) § 7 UWG (insbesondere Belästigung durch elektronische Direktwerbung),</li>
        <li>(b) Verordnung (EU) 2016/679 - Datenschutz-Grundverordnung (DSGVO), einschließlich Art. 6, 13, 14, 21 DSGVO,</li>
        <li>(c) Bundesdatenschutzgesetz (BDSG),</li>
        <li>(d) Telekommunikation-Digitale-Dienste-Datenschutz-Gesetz (TDDDG, vormals TTDSG),</li>
        <li>(e) Richtlinie 2002/58/EG („ePrivacy-Richtlinie“) und ihre nationalen Umsetzungen,</li>
        <li>(f) urheber-, marken-, wettbewerbs- und persönlichkeitsrechtliche Vorschriften,</li>
        <li>(g) ausländische Vorschriften, soweit anwendbar (u. a. CAN-SPAM Act, CASL, UK GDPR, ePrivacy-Regelungen anderer Mitgliedstaaten).</li>
      </ul>
      <p>
        4.3 Der Kunde versichert insbesondere, dass er für jeden Empfänger über eine
        tragfähige Rechtsgrundlage verfügt (z. B. mutmaßliches berechtigtes Interesse nach
        Art. 6 Abs. 1 lit. f DSGVO i. V. m. Erwägungsgrund 47 für B2B-Kommunikation, soweit
        einschlägig, oder eine wirksame Einwilligung) und dass er die Informationspflichten
        nach Art. 13/14 DSGVO sowie ein wirksames, leicht zugängliches Widerspruchs- bzw.
        Abmeldeverfahren („Opt-out“) implementiert.
      </p>
      <p>
        4.4 Der Kunde ist verpflichtet, eine wahrheitsgemäße Absenderkennung, ein gültiges
        Impressum (soweit anwendbar) sowie eine korrekte „From“-Adresse zu verwenden. Die
        Verschleierung oder Verheimlichung der Identität des Absenders ist untersagt.
      </p>
      <p>
        4.5 Untersagt ist insbesondere die Nutzung der Plattform zum Versand von Spam,
        Phishing, betrügerischen, irreführenden, sittenwidrigen, jugendgefährdenden,
        diskriminierenden, gewaltverherrlichenden oder strafrechtlich relevanten Inhalten.
        Untersagt ist ferner das Hochladen oder die Verarbeitung besonderer Kategorien
        personenbezogener Daten im Sinne des Art. 9 DSGVO ohne ausreichende Rechtsgrundlage.
      </p>
      <p>
        4.6 Der Kunde ist verpflichtet, Sender-Domains, DNS-Einträge (insbesondere SPF,
        DKIM, DMARC), Mailbox-Konfigurationen und Aufwärmprozesse selbst sachgerecht zu
        konfigurieren und laufend zu prüfen. BonusClub übernimmt für die ordnungsgemäße
        Konfiguration, Reputation oder Zustellbarkeit der vom Kunden eingesetzten Drittsysteme
        keine Verantwortung.
      </p>
      <p>
        4.7 Der Kunde ist verpflichtet, Beschwerden, Widersprüche, Auskunfts- und
        Löschverlangen Betroffener unverzüglich und eigenständig zu bearbeiten und betroffene
        Empfänger unverzüglich aus seinen Listen zu entfernen.
      </p>

      <h2>5. Auftragsverarbeitung gemäß Art. 28 DSGVO</h2>
      <p>
        5.1 Soweit BonusClub im Rahmen der Bereitstellung des Dienstes personenbezogene Daten
        im Auftrag des Kunden verarbeitet, geschieht dies ausschließlich auf Grundlage einer
        gesonderten Auftragsverarbeitungsvereinbarung („AVV“ / „DPA“) gemäß Art. 28 DSGVO,
        abrufbar unter{' '}
        <a href="https://www.bonusclub.io/dpa" target="_blank" rel="noopener noreferrer">
          https://www.bonusclub.io/dpa
        </a>
        . Die AVV wird mit Vertragsschluss Bestandteil dieses Vertrages.
      </p>
      <p>
        5.2 Der Kunde ist Verantwortlicher im Sinne des Art. 4 Nr. 7 DSGVO. BonusClub ist
        Auftragsverarbeiter im Sinne des Art. 4 Nr. 8 DSGVO. BonusClub trifft keine
        Entscheidungen über die Zwecke und wesentlichen Mittel der Verarbeitung.
      </p>
      <p>
        5.3 Soweit ein Drittlandtransfer in die USA oder andere Drittländer erfolgt, stützt
        sich BonusClub auf geeignete Garantien im Sinne der Art. 44 ff. DSGVO, insbesondere
        Standardvertragsklauseln (SCC) der Europäischen Kommission und/oder das
        EU-US Data Privacy Framework, soweit anwendbar. Details ergeben sich aus der AVV.
      </p>

      <h2>6. Vergütung, Zahlungsbedingungen, Verzug</h2>
      <p>
        6.1 Die Vergütung richtet sich nach dem vom Kunden gewählten Tarif bzw. der
        individuellen Angebotsvereinbarung. Sämtliche Preise verstehen sich - soweit nicht
        ausdrücklich anders ausgewiesen - netto zzgl. der jeweils gesetzlichen Umsatzsteuer.
      </p>
      <p>
        6.2 Die Vergütung ist im Voraus für den jeweiligen Abrechnungszeitraum (monatlich
        oder jährlich) zur Zahlung fällig. Zahlungen erfolgen über die jeweils angebotenen
        Zahlungsmittel.
      </p>
      <p>
        6.3 Bei Zahlungsverzug ist BonusClub berechtigt, Verzugszinsen in gesetzlicher Höhe
        nach § 288 Abs. 2 BGB sowie eine Pauschale nach § 288 Abs. 5 BGB zu verlangen. Der
        Nachweis eines höheren Schadens bleibt vorbehalten.
      </p>
      <p>
        6.4 BonusClub ist bei nicht unerheblichem Zahlungsverzug oder begründetem
        Missbrauchsverdacht berechtigt, den Zugang zum Dienst nach vorheriger Mahnung
        vorübergehend zu sperren oder zu beschränken, ohne dass dem Kunden hieraus Ansprüche
        erwachsen.
      </p>
      <p>
        6.5 Die Aufrechnung mit Gegenforderungen des Kunden ist nur zulässig, soweit diese
        unbestritten oder rechtskräftig festgestellt sind. Ein Zurückbehaltungsrecht steht
        dem Kunden nur bei Forderungen aus demselben Vertragsverhältnis zu.
      </p>

      <h2>7. Laufzeit und Kündigung</h2>
      <p>
        7.1 Die Vertragslaufzeit ergibt sich aus dem gewählten Tarif. Bei Monatsabos
        verlängert sich der Vertrag jeweils automatisch um einen weiteren Monat, bei
        Jahresabos um ein weiteres Jahr, sofern er nicht mit einer Frist von 14 Tagen zum
        Ende der jeweiligen Laufzeit gekündigt wird, soweit nicht abweichend vereinbart.
      </p>
      <p>
        7.2 Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
        Ein wichtiger Grund liegt für BonusClub insbesondere vor bei (a) erheblichem
        Zahlungsverzug, (b) wesentlichem Verstoß gegen Ziffer 4 dieser AGB, (c) drohender
        oder eingetretener Beeinträchtigung der Reputation, Sicherheit oder Verfügbarkeit
        der Plattform durch das Verhalten des Kunden, (d) Insolvenz oder vergleichbarer
        wirtschaftlicher Lage des Kunden.
      </p>
      <p>
        7.3 Kündigungen bedürfen der Textform (§ 126b BGB).
      </p>
      <p>
        7.4 Mit Vertragsende endet das Nutzungsrecht des Kunden. BonusClub ist berechtigt,
        Daten des Kunden 30 Tage nach Vertragsende zu löschen, soweit keine gesetzlichen
        Aufbewahrungspflichten entgegenstehen. Der Kunde ist verpflichtet, vor Vertragsende
        einen Datenexport vorzunehmen.
      </p>

      <h2>8. Verfügbarkeit, Wartung, Beta-Funktionen</h2>
      <p>
        8.1 BonusClub bemüht sich um eine möglichst hohe Verfügbarkeit des Dienstes.
        Eine bestimmte Verfügbarkeit (SLA) wird - außerhalb individueller schriftlicher
        Vereinbarungen - nicht geschuldet. Der Dienst wird „as is“ und „as available“ zur
        Verfügung gestellt.
      </p>
      <p>
        8.2 BonusClub ist berechtigt, Wartungsfenster, Updates und Anpassungen ohne
        vorherige Ankündigung durchzuführen, soweit dies aus Sicherheits- oder
        Stabilitätsgründen erforderlich ist. Geplante, längere Ausfallzeiten kündigt
        BonusClub mit angemessener Frist an.
      </p>
      <p>
        8.3 Beta-, Vorschau- und experimentelle Funktionen werden ohne Gewährleistung
        bereitgestellt und können jederzeit eingestellt werden.
      </p>

      <h2>9. Mitwirkungspflichten, Drittanbieter</h2>
      <p>
        9.1 Der Kunde ist verpflichtet, sämtliche zur Vertragserfüllung erforderlichen
        Mitwirkungshandlungen rechtzeitig, vollständig und in geeigneter Form vorzunehmen.
      </p>
      <p>
        9.2 Sofern der Kunde Drittsysteme (z. B. Google Workspace, Microsoft 365,
        SMTP-Provider, CRM-Systeme, Anreicherungs- oder Verifikationsdienste) anbindet, gelten
        deren Nutzungsbedingungen ausschließlich im Verhältnis zwischen dem Kunden und dem
        jeweiligen Drittanbieter. BonusClub haftet weder für Verfügbarkeit, Funktionsumfang
        oder Konfiguration noch für etwaige Verstöße des Kunden gegen Bedingungen dieser
        Drittanbieter.
      </p>

      <h2>10. Haftung</h2>
      <p>
        10.1 BonusClub haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit, für
        Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit, nach den
        Vorschriften des Produkthaftungsgesetzes sowie im Rahmen einer ausdrücklich
        übernommenen Garantie.
      </p>
      <p>
        10.2 Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten
        (Kardinalpflichten) ist die Haftung auf den vertragstypischen, vorhersehbaren
        Schaden begrenzt. Wesentliche Vertragspflichten sind solche, deren Erfüllung die
        ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und auf deren
        Einhaltung der Kunde regelmäßig vertrauen darf.
      </p>
      <p>
        10.3 Im Übrigen ist die Haftung von BonusClub - gleich aus welchem Rechtsgrund -
        ausgeschlossen, insbesondere für entgangenen Gewinn, mittelbare Schäden,
        Reputationsschäden, Datenverluste, Folgeschäden, Bußgelder, Geldbußen,
        Vertragsstrafen, Abmahnkosten, Anwaltskosten oder Schadensersatz, die aus den vom
        Kunden über die Plattform durchgeführten Outreach-, Marketing- oder
        Kommunikationsaktivitäten resultieren.
      </p>
      <p>
        10.4 Soweit die Haftung von BonusClub ausgeschlossen oder beschränkt ist, gilt
        dies auch für die persönliche Haftung der Organe, Mitarbeiter, Vertreter und
        Erfüllungsgehilfen.
      </p>
      <p>
        10.5 Die summenmäßige Haftung von BonusClub für sämtliche Schadensereignisse
        innerhalb von zwölf (12) Monaten ist - soweit gesetzlich zulässig - auf die in den
        zwölf (12) Monaten vor dem schadensauslösenden Ereignis vom Kunden tatsächlich
        gezahlten Nettoentgelte begrenzt. Diese Begrenzung gilt nicht für Schäden gemäß
        Ziffer 10.1.
      </p>

      <h2>11. Freistellung des Anbieters</h2>
      <p>
        11.1 Der Kunde stellt BonusClub sowie deren Organe, Mitarbeiter, Vertreter und
        Erfüllungsgehilfen auf erstes Anfordern von sämtlichen Ansprüchen Dritter frei, die
        diese gegen BonusClub aufgrund der vom Kunden über die Plattform durchgeführten
        Aktivitäten geltend machen, insbesondere im Zusammenhang mit:
      </p>
      <ul>
        <li>(a) Verstößen gegen § 7 UWG (unzumutbare Belästigung) sowie damit verbundenen Abmahnungen, einstweiligen Verfügungen, Unterlassungs-, Auskunfts- oder Schadensersatzansprüchen,</li>
        <li>(b) Verstößen gegen die DSGVO, das BDSG, das TDDDG oder andere datenschutzrechtliche Vorschriften, einschließlich aufsichtsbehördlicher Verfahren, Bußgelder und Schadensersatzansprüche Betroffener (z. B. nach Art. 82 DSGVO),</li>
        <li>(c) Verstößen gegen Persönlichkeits-, Urheber-, Marken- oder Wettbewerbsrechte Dritter,</li>
        <li>(d) Verstößen gegen Nutzungsbedingungen von Drittanbietern (z. B. Google Workspace, Microsoft 365),</li>
        <li>(e) Verstößen gegen ausländische Antispam-, Telemarketing- oder Datenschutzvorschriften (u. a. CAN-SPAM, CASL, UK GDPR).</li>
      </ul>
      <p>
        11.2 Die Freistellungspflicht umfasst auch die Erstattung sämtlicher angemessener
        Kosten der Rechtsverteidigung, einschließlich Anwalts- und Gerichtskosten.
      </p>
      <p>
        11.3 BonusClub wird den Kunden über etwaige Inanspruchnahmen unverzüglich informieren
        und ihm - soweit rechtlich zulässig - Gelegenheit zur Verteidigung geben.
      </p>

      <h2>12. Gewährleistung</h2>
      <p>
        12.1 BonusClub gewährleistet, dass der Dienst im Wesentlichen den vereinbarten
        Funktionalitäten entspricht. Eine Gewährleistung für eine ununterbrochene oder
        fehlerfreie Verfügbarkeit besteht nicht.
      </p>
      <p>
        12.2 Mängel sind unverzüglich nach Entdeckung in Textform zu rügen. Der Kunde
        unterstützt BonusClub bei der Eingrenzung und Behebung etwaiger Mängel.
      </p>
      <p>
        12.3 Die verschuldensunabhängige Haftung nach § 536a Abs. 1 Alt. 1 BGB für bereits
        bei Vertragsschluss vorhandene Mängel ist - soweit gesetzlich zulässig -
        ausgeschlossen.
      </p>

      <h2>13. Nutzungsrechte und Schutzrechte</h2>
      <p>
        13.1 Sämtliche Rechte an der Plattform, der zugrundeliegenden Software, den
        zugehörigen Marken, Logos und Inhalten verbleiben ausschließlich bei BonusClub bzw.
        den jeweiligen Lizenzgebern. Der Kunde erhält ein einfaches, nicht übertragbares,
        nicht unterlizenzierbares, zeitlich auf die Vertragslaufzeit beschränktes Recht zur
        vertragsgemäßen Nutzung des Dienstes.
      </p>
      <p>
        13.2 Reverse Engineering, Dekompilierung, Disassemblierung sowie das Kopieren,
        Verändern, Vervielfältigen oder Vermieten der Software sind - soweit gesetzlich
        zulässig - untersagt.
      </p>
      <p>
        13.3 Der Kunde räumt BonusClub das nicht ausschließliche, weltweite Recht ein, die
        vom Kunden eingestellten Daten ausschließlich zum Zweck der Vertragserfüllung
        sowie zu Zwecken der Sicherheit, Stabilität und Weiterentwicklung der Plattform in
        anonymisierter oder aggregierter Form zu verarbeiten.
      </p>

      <h2>14. Vertraulichkeit</h2>
      <p>
        14.1 Die Parteien verpflichten sich, alle vertraulichen Informationen der jeweils
        anderen Partei vertraulich zu behandeln, nicht an Dritte weiterzugeben und nur für
        Zwecke der Vertragserfüllung zu verwenden. Diese Pflicht besteht für die Dauer von
        drei (3) Jahren nach Vertragsende fort.
      </p>
      <p>
        14.2 Vertrauliche Informationen sind alle als vertraulich gekennzeichneten oder
        ihrer Natur nach vertraulichen Informationen, insbesondere Geschäftsgeheimnisse im
        Sinne des GeschGehG.
      </p>

      <h2>15. Höhere Gewalt</h2>
      <p>
        Im Falle höherer Gewalt - einschließlich, aber nicht beschränkt auf Naturkatastrophen,
        Krieg, Aufruhr, Streiks, Aussperrungen, behördliche Anordnungen, Pandemien sowie
        großflächige Ausfälle bei Vorleistern, Cloud-Anbietern oder Internetinfrastruktur -
        sind die Parteien für die Dauer und im Umfang der Auswirkungen von ihren
        Leistungspflichten befreit. Schadensersatzansprüche sind in diesen Fällen
        ausgeschlossen.
      </p>

      <h2>16. Änderungen dieser AGB</h2>
      <p>
        16.1 BonusClub ist berechtigt, diese AGB anzupassen, insbesondere bei Änderungen
        der Rechtslage, höchstrichterlicher Rechtsprechung, technischer
        Rahmenbedingungen oder bei Erweiterung des Leistungsangebots.
      </p>
      <p>
        16.2 Änderungen werden dem Kunden in Textform mit einer Frist von mindestens 30 Tagen
        vor ihrem Inkrafttreten angekündigt. Widerspricht der Kunde nicht innerhalb dieser
        Frist in Textform, gelten die Änderungen als angenommen. Hierauf wird BonusClub bei
        Ankündigung gesondert hinweisen. Im Falle eines Widerspruchs ist BonusClub
        berechtigt, das Vertragsverhältnis zum Zeitpunkt des Inkrafttretens der Änderung zu
        beenden.
      </p>

      <h2>17. Anwendbares Recht, Gerichtsstand, EU-/EWR-Sondervorschriften</h2>
      <p>
        17.1 Auf das Vertragsverhältnis findet ausschließlich das Recht der Bundesrepublik
        Deutschland unter Ausschluss des UN-Kaufrechts (CISG) und unter Ausschluss von
        Kollisionsnormen Anwendung.
      </p>
      <p>
        17.2 Ausschließlicher Gerichtsstand für sämtliche Streitigkeiten aus oder im
        Zusammenhang mit diesem Vertrag ist - soweit der Kunde Kaufmann, juristische Person
        des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist - der Sitz
        des deutschen Geschäftsbetriebs von BonusClub bzw., soweit ein solcher nicht besteht,
        Berlin. BonusClub ist daneben berechtigt, den Kunden auch an dessen allgemeinem
        Gerichtsstand zu verklagen.
      </p>
      <p>
        17.3 Soweit Kunden in der Europäischen Union oder im Europäischen Wirtschaftsraum
        ansässig sind, bleiben zwingende Vorschriften des Rechts ihres gewöhnlichen
        Aufenthaltsstaates - insbesondere Vorschriften des Datenschutzrechts (DSGVO und
        nationale Umsetzungen), des Wettbewerbsrechts (z. B. UWG) sowie sonstige
        international zwingend anwendbare Vorschriften - unberührt.
      </p>

      <h2>18. Schlussbestimmungen</h2>
      <p>
        18.1 Sollten einzelne Bestimmungen dieser AGB unwirksam oder undurchführbar sein
        oder werden, so wird hiervon die Wirksamkeit der übrigen Bestimmungen nicht
        berührt. Die Parteien verpflichten sich, anstelle der unwirksamen oder
        undurchführbaren Bestimmung eine wirksame Bestimmung zu vereinbaren, die dem
        wirtschaftlichen Zweck der unwirksamen oder undurchführbaren Bestimmung am nächsten
        kommt.
      </p>
      <p>
        18.2 Änderungen und Ergänzungen dieses Vertrages bedürfen der Textform. Dies gilt
        auch für die Aufhebung dieses Textformerfordernisses.
      </p>
      <p>
        18.3 Eine Übertragung von Rechten und Pflichten aus diesem Vertrag durch den
        Kunden bedarf der vorherigen schriftlichen Zustimmung von BonusClub.
      </p>

      <h2>19. Kontakt</h2>
      <p>
        Rechtliche Anfragen:{' '}
        <a href="mailto:julian@bonusclub.io">julian@bonusclub.io</a>
      </p>
      <p>
        Allgemeine Anfragen:{' '}
        <a href="https://www.bonusclub.io" target="_blank" rel="noopener noreferrer">
          www.bonusclub.io
        </a>
      </p>

      <hr />

      <p>
        <strong>© 2026 BonusClub LLC. Alle Rechte vorbehalten.</strong>
      </p>
    </div>
  );
};

export default AGB;
